import React from 'react';
import './NewFooter.css';

const NewFooter = () => {
  return (
    <footer className="new-footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <h2 className="footer-brand-name">ADCI</h2>
          <p className="footer-tagline">
            Empowering aspirants to achieve excellence in defence careers through comprehensive training and guidance.
          </p>
        </div>
        <div className="footer-info">
          <div className="footer-contact">
            <div className="contact-group">
              <div className="contact-label">Address</div>
              <p className="contact-text">
                S.no.125, Sai Niketan Colony, Near Madhuban Society,
                Alandi Rd, Vishrant Wadi, Pune, Maharashtra 411015
              </p>
            </div>
            <div className="contact-group">
              <div className="contact-label">Contact</div>
              <p className="contact-text">
                Phone: +91 9890826344, +91 9021305751<br />
                Email: kutty.anees@gmail.com
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-links">
          <a href="https://www.aneesclasses.com" className="footer-link" target="_blank" rel="noopener noreferrer">
            www.aneesclasses.com
          </a>
        </div>
        <p className="copyright">
          {new Date().getFullYear()} Anees Defence Career Institute. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default NewFooter;
